module.exports = __webpack_public_path__ + "img/print.2457ff2a.svg";